import type { LocationHistoryMinimal } from '~hooks/useLocationHistory/models';

import DistanceRouteMap, { MapLoader } from './DistanceRouteMap';

interface Props {
  pings: LocationHistoryMinimal[];
  isLoading: boolean;
}

const DistanceMapDriverDay = ({ pings, isLoading }: Props) => {
  if (isLoading) {
    return <MapLoader />;
  }

  return <DistanceRouteMap pings={pings} />;
};

export default DistanceMapDriverDay;
